import { useCallback, useEffect, useRef, useState } from 'react';
const STEP_MS = 100;
const DURATION_MS = 80000;
export const useVideoProgress = ()=>{
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef(null);
    const start = useCallback(()=>{
        if (intervalRef.current) return;
        const increment = STEP_MS / DURATION_MS * 100;
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                const next = prev + increment;
                if (next >= 100) {
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                    return 100;
                }
                return next;
            });
        }, STEP_MS);
    }, []);
    const pause = useCallback(()=>{
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    const reset = useCallback(()=>{
        pause();
        setProgress(0);
    }, [
        pause
    ]);
    useEffect(()=>()=>pause(), [
        pause
    ]);
    return {
        progress,
        start,
        pause,
        reset
    };
};
